/** Normalizes viewDriver API payloads for driver detail / edit screens. */
export const mapViewToForm = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  let d = raw?.driver ?? raw;
  if (Array.isArray(raw?.driver_data) && raw.driver_data.length) {
    d = raw.driver_data[0];
  } else if (
    raw?.driver_data &&
    typeof raw.driver_data === "object" &&
    !Array.isArray(raw.driver_data)
  ) {
    d = raw.driver_data;
  }

  const loc = d?.mipl_location_id;
  const toDateInput = (v) => {
    if (v == null || v === "") return "";
    const s = String(v);
    return s.includes("T") ? s.slice(0, 10) : s.slice(0, 10);
  };

  const exp = d?.license_expiry_date;
  const ntExp = d?.nt_license_expiry_date;
  const created =
    d?.license_creation_date ?? d?.license_issue_date ?? d?.license_created_date ?? "";
  const profileImage =
    typeof d?.profile_image === "string" ? d.profile_image.trim() : "";
  const documentData = Array.isArray(d?.document_data) ? d.document_data : [];

  return {
    fullName: (d?.full_name ?? "").trim(),
    licenseNumber: (d?.license_number ?? "").trim(),
    licenseCreation: created ? toDateInput(created) : "",
    licenseExpiry: exp ? toDateInput(exp) : "",
    ntLicenseExpiry: ntExp ? toDateInput(ntExp) : "",
    adharNumber: (d?.adhar_card_number ?? d?.aadhar_card_number ?? "").trim(),
    mobile: (d?.mobile_number ?? "").toString().replace(/\D/g, "").slice(0, 10),
    countryCode: (d?.country_code ?? "+91").trim() || "+91",
    age: d?.age != null && d?.age !== "" ? String(d.age) : "",
    accountantName: d?.accountant_name ?? d?.accountant_id?.full_name ?? "",
    miplLocation:
      (typeof loc === "object" && loc?.name) || d?.mipl_location?.name || "",
    driverRefId: d?.driver_ref_id,
    profileImage,
    documentData,
  };
};
